<div class="div">
    <router-outlet></router-outlet>
</div>